export const BASE_LINE = 80
export const ROOT_ID = '#___gatsby'
export const INTERSECTION_OBSERVER_ROOT_MARGIN = '-100px'
export const INTERSECTION_OBSERVER_THRESHOLD = 0.8
